import type { YAxisProps } from "recharts";

import type { ValueAxisConfig } from "./charts.types";

export const CHART_HEIGHT_CLASS = "h-72";
export const CHART_CONTAINER_CLASS = `aspect-auto ${CHART_HEIGHT_CLASS} w-full`;
export const CHART_MARGIN = { left: 0, right: 8, top: 8 };
export const X_AXIS_PROPS = { axisLine: false, tickLine: false, tickMargin: 8 };

type ValueYAxisProps = Pick<
  YAxisProps,
  | "allowDecimals"
  | "axisLine"
  | "domain"
  | "tickFormatter"
  | "tickLine"
  | "ticks"
  | "width"
>;

export function getValueYAxisProps(
  valueAxis: ValueAxisConfig,
): ValueYAxisProps {
  return {
    allowDecimals: false,
    axisLine: false,
    domain: valueAxis.domain,
    tickFormatter: valueAxis.formatTick,
    tickLine: false,
    ticks: valueAxis.tickList,
    width: valueAxis.width,
  };
}
